// extracted by mini-css-extract-plugin
module.exports = {"skipToContent":"skipToContent_skipToContent__7cWrb"};